export default "__VITE_ASSET__DBmjZhZF__"